import { render } from "./mainnav.vue?vue&type=template&id=89464102&scoped=true"
import script from "./mainnav.vue?vue&type=script&lang=js"
export * from "./mainnav.vue?vue&type=script&lang=js"

import "./mainnav.vue?vue&type=style&index=0&id=89464102&scoped=true&lang=css"

import exportComponent from "../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89464102"]])

export default __exports__